// Desktop Images Data for Carousel
export const DESKTOP_DATA2 = [
    { 
        id: "01", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page2/Asset004.png",
        width: "auto",
        height: "auto"
    },
    { 
        id: "02", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page2/Asset005.png",
        width: "auto",
        height: "auto"
    },
    { 
        id: "03", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page2/Asset006.png",
        width: "auto",
        height: "auto"
    }
];

// Mobile Images Data for Carousel
export const MOBILE_DATA2 = [
    { 
        id: "01", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page2/Asset004.png",
        width: "100%",
        height: 300
    },
    { 
        id: "02", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page2/Asset005.png",
        width: "100%",
        height: 280
    },
    { 
        id: "03", 
        img: "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page2/Asset006.png",
        width: "100%",
        height: 320
    }
];